var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useRef } from "react";
import { useWindowSize } from "../../hooks/use-window-size";
import { ginni } from "@shapeable/utils";
export function useOptionMenuPosition(args) {
  var _a;
  var isOpen = args.isOpen,
    triggerRef = args.triggerRef,
    footRef = args.footRef,
    _b = args.buffer,
    buffer = _b === void 0 ? 8 : _b,
    _c = args.headPadding,
    headPadding = _c === void 0 ? 0 : _c,
    _d = args.footPadding,
    footPadding = _d === void 0 ? 0 : _d,
    headRef = args.headRef,
    deps = args.deps;
  var _e = __read(useState("below"), 2),
    position = _e[0],
    setPosition = _e[1];
  var _f = __read(useState(), 2),
    maxHeight = _f[0],
    setMaxHeight = _f[1];
  var _g = __read(useState(), 2),
    maxItemsHeight = _g[0],
    setMaxItemsHeight = _g[1];
  var menuItemsRef = useRef(null);
  var windowSize = useWindowSize();
  var menuHeight = ((_a = menuItemsRef === null || menuItemsRef === void 0 ? void 0 : menuItemsRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0; // Natural menu height
  useEffect(function () {
    var _a, _b;
    if (!isOpen || !triggerRef.current || !menuItemsRef.current) return;
    var triggerRect = triggerRef.current.getBoundingClientRect();
    var headRect = (_a = headRef === null || headRef === void 0 ? void 0 : headRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var footRect = (_b = footRef === null || footRef === void 0 ? void 0 : footRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var chromeHeight = ((headRect === null || headRect === void 0 ? void 0 : headRect.height) || 0) + ((footRect === null || footRect === void 0 ? void 0 : footRect.height) || 0) + ((headRef === null || headRef === void 0 ? void 0 : headRef.current) ? headPadding : 0) + ((footRef === null || footRef === void 0 ? void 0 : footRef.current) ? footPadding : 0);
    var viewportHeight = window.innerHeight;
    var spaceBelow = viewportHeight - triggerRect.bottom;
    var spaceAbove = triggerRect.top;
    // this needs a recalc here, as closure value is not updated
    // const menuHeight = menuItemsRef?.current?.scrollHeight || 0; // Natural menu height
    // TODO - make the menu positioning work correctly for now, we'll just use below always
    // if (menuHeight <= spaceBelow) {
    //   setPosition("below");
    //   setMaxHeight(undefined);
    // } else if (menuHeight <= spaceAbove) {
    //   setPosition("above");
    //   setMaxHeight(undefined);
    // } else {
    //   if (spaceBelow > spaceAbove) {
    //     setPosition("below");
    //     setMaxHeight(spaceBelow - buffer);
    //     setMaxItemsHeight(spaceBelow - chromeHeight - buffer);
    //   } else {
    //     // setPosition("above");
    //     setPosition("below");
    //     setMaxHeight(spaceAbove - buffer);
    //     setMaxItemsHeight(spaceAbove - chromeHeight - buffer);
    //   }
    // }
    ginni.verbose.log("UseOptionMenuPosition", {
      menuHeight: menuHeight,
      spaceBelow: spaceBelow,
      spaceAbove: spaceAbove,
      triggerRect: triggerRect,
      headRect: headRect,
      footRect: footRect
    });
    setPosition("below");
    setMaxHeight(spaceBelow - buffer);
    setMaxItemsHeight(spaceBelow - chromeHeight - buffer);
  }, __spreadArray([isOpen, triggerRef, headRef, footRef, menuHeight, windowSize.height], __read(deps), false));
  var result = {
    position: position,
    maxHeight: maxHeight,
    menuHeight: menuHeight,
    maxItemsHeight: maxItemsHeight,
    menuItemsRef: menuItemsRef
  };
  // ginni.log("useOptionMenuPosition  result", result);
  return result;
}